import React, { useState } from 'react'
import CancellationForm, {
  CancellationFormDataType,
} from '../components/forms/CancellationForm'
import { AttachmentType, CaseReportId } from '../models'

const caseReportId: CaseReportId = '123'

const initialCancellationFormData: CancellationFormDataType = {
  caseCommon: {
    // NYNI JE NUTNE INICIALIZOVAT DESTINACI !!!
    destination: 'AND',
  },
  caseCA: {
    // reason: 'CHRONIC',
    // insuredRelation: 'FATHER',
    attachmentList: [
      {
        attachmentType: AttachmentType.RECEIPT,
        attachments: [
          {
            attachmentId: '123',
            fileName: 'muj soubour.xlsx',
          },
        ],
      },
      {
        attachmentType: AttachmentType.SUPPORT,
        attachments: [
          {
            attachmentId: '765',
            fileName: 'test soubor.xlsx',
          },
        ],
      },
      {
        attachmentType: AttachmentType.INVOICE,
        attachments: [],
      },
    ],
  },
}

const CancellationDebug = () => {
  const [cancellationFormData, setCancellationFormData] = useState<
    CancellationFormDataType | object
  >(initialCancellationFormData)

  const handleCancellationFormPageSubmitted = (
    value: CancellationFormDataType
  ) => {
    alert(
      'DEBUG\nCancellationPage submitted\nNow the page will be reset to blank data...'
    )
    // reset data in the form to empty data
    setCancellationFormData({})

    // delay 10 sec
    new Promise((resolve) => setTimeout(resolve, 10000)).then(() => {
      alert('DEBUG\nNow we will display the previously edited values...')
      console.log(value, 'value from Debug')
      setCancellationFormData(value)
    })
  }

  const handleCancellationPageBack = () => {
    alert('Page back')
  }

  return (
    <CancellationForm
      caseReportId={caseReportId}
      cancellationData={cancellationFormData}
      isContinueInProgress={false}
      errorMessage={''}
      onPageContinue={handleCancellationFormPageSubmitted}
      onPageBack={handleCancellationPageBack}
      setIfEqual={(isChanged: boolean) => {
        /* ignore */
      }}
    />
  )
}

export default CancellationDebug
